export class ELIMSResult {
    NbFiber: number;
    SA: number;
    ResultConcentration: number;

    static mapFromJSON(json): ELIMSResult {
        const r = new ELIMSResult;

        r.NbFiber = json['nbFiber'];
        r.SA = json['sa'];
        r.ResultConcentration = json['resultConcentration'];

        return r;
    }
}